import dynamic from "next/dynamic";

import { postEvent, resetSession } from "./Analytics";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useRouter } from "next/router";
import { trackVirtualPageView } from "~/utils/Fetch/Analytics";
const MessageAgentModal = dynamic(() => import("./MessageAgentModal"), {
  ssr: false,
});
const MessageAgentForm = dynamic(() => import("./MessageAgentForm"), {
  ssr: false,
});
/**
 * MessageAgentButton
 *
 * Message agent button component with message agent modal.
 *
 * @param {*} props
 * @returns
 */
const MessageAgentButton = (props) => {
  const {
    agent,
    children,
    useContactForm,
    className,
    funnel,
    isPrime,
    isNonPrime,
    city,
    state,
    skipLocation,
    noCompetingProposals,
    messageHeader,
    agentPage,
    onClick,
    noViewAgents,
    onClose,
  } = props;

  const [confirmClose, setConfirmClose] = useState(false);
  const [largeModal, setLargeModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const router = useRouter();

  /**
   * onRequestClose
   *
   * Logic for displaying the confirm close screen
   *
   * @param {event} e
   * @param {bool} confirm
   */
  const onRequestClose = (e, confirm = false) => {
    if (confirm) {
      setConfirmClose(true);
      postEvent(
        "message_agent_modal_exit_attempt",
        router,
        agent.rea_agent_status,
        funnel
      );
    } else if (confirm === null) {
      setConfirmClose(false);
    } else {
      setModalOpen(false);
      onClose && onClose();
      postEvent(
        "message_agent_modal_closed",
        router,
        agent.rea_agent_status,
        funnel
      );
      resetSession();
      setTimeout(() => {
        setConfirmClose(false);
      }, 200);
    }
  };

  return (
    <>
      <button
        className={`MessageAgentButton ${className}`}
        onClick={(e) => {
          onClick && onClick(e);
          setLargeModal(false);
          setModalOpen(true);
          trackVirtualPageView("funnel_start", funnel);
          postEvent(
            "message_agent_button_clicked",
            router,
            agent.rea_agent_status,
            funnel
          );
          resetSession();
        }}
      >
        {children}
      </button>
      {modalOpen && (
        <MessageAgentModal
          confirmClose={confirmClose}
          isOpen={modalOpen}
          largeModal={largeModal}
          onRequestClose={onRequestClose}
          agent={agent}
          funnel={funnel}
          skipLocation={skipLocation}
          noCompetingProposals={noCompetingProposals}
          messageHeader={messageHeader}
          useContactForm={useContactForm}
          agentPage={agentPage}
        >
          <MessageAgentForm
            agent={agent}
            funnel={funnel}
            onRequestClose={onRequestClose}
            onRequestLargeModal={setLargeModal}
            useContactForm={useContactForm}
            isPrime={isPrime}
            isNonPrime={isNonPrime}
            city={city}
            state={state}
            noViewAgents={noViewAgents}
          />
        </MessageAgentModal>
      )}
    </>
  );
};

MessageAgentButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.node,
    PropTypes.object,
  ]),
  className: PropTypes.string,
  funnel: PropTypes.string,
};

MessageAgentButton.defaultProps = {
  children: [],
  className: "",
  funnel: "message_agent_2",
};

export default MessageAgentButton;
